<template>
  <div class="plat-teacher">
    <PlatDataGridSite grid-id="PeTeacher"
                      show-label></PlatDataGridSite>
  </div>
</template>

<script>
import PlatDataGridSite from '../../../wrapper/grid/PlatDataGridSite'
export default {
  name: 'PlatTeacher',
  components: {
    PlatDataGridSite
  }
}
</script>

<style lang="scss">
  .plat-teacher {
    height: 100%;
  }
</style>
